// source: tprmquestionnaire/tprmquestionnaire.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
goog.exportSymbol('proto.tprmquestionnaire.Comment', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ConditionRule', null, global);
goog.exportSymbol('proto.tprmquestionnaire.CreateCommentRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.Empty', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ExportFormCsvRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ExportFormCsvResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.FormOption', null, global);
goog.exportSymbol('proto.tprmquestionnaire.FormQuestion', null, global);
goog.exportSymbol('proto.tprmquestionnaire.FormSection', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetQuestionnaireFormRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ImportFormCsvRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ImportFormCsvResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListCommentThreadRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListCommentThreadResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListReceivedQuestionnairesRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListReceivedQuestionnairesResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionResponseType', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionnaireCommentAuthorSide', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionnaireForm', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionnaireRequestSummary', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionnaireTemplate', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SendQuestionnaireRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SendQuestionnaireResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SupplementalInput', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SupplementalInputKind', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SupplementalInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SupplementalInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SupplementalInput.displayName = 'proto.tprmquestionnaire.SupplementalInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ConditionRule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ConditionRule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ConditionRule.displayName = 'proto.tprmquestionnaire.ConditionRule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.FormOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.FormOption.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.FormOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.FormOption.displayName = 'proto.tprmquestionnaire.FormOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.FormQuestion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.FormQuestion.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.FormQuestion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.FormQuestion.displayName = 'proto.tprmquestionnaire.FormQuestion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.FormSection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.FormSection.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.FormSection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.FormSection.displayName = 'proto.tprmquestionnaire.FormSection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.QuestionnaireForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.QuestionnaireForm.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.QuestionnaireForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.QuestionnaireForm.displayName = 'proto.tprmquestionnaire.QuestionnaireForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.QuestionnaireTemplate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.QuestionnaireTemplate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.QuestionnaireTemplate.displayName = 'proto.tprmquestionnaire.QuestionnaireTemplate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.displayName = 'proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.displayName = 'proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.GetQuestionnaireFormRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetQuestionnaireFormRequest.displayName = 'proto.tprmquestionnaire.GetQuestionnaireFormRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ExportFormCsvRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ExportFormCsvRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ExportFormCsvRequest.displayName = 'proto.tprmquestionnaire.ExportFormCsvRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ExportFormCsvResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ExportFormCsvResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ExportFormCsvResponse.displayName = 'proto.tprmquestionnaire.ExportFormCsvResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ImportFormCsvRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ImportFormCsvRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ImportFormCsvRequest.displayName = 'proto.tprmquestionnaire.ImportFormCsvRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ImportFormCsvResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ImportFormCsvResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ImportFormCsvResponse.displayName = 'proto.tprmquestionnaire.ImportFormCsvResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SendQuestionnaireRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SendQuestionnaireRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SendQuestionnaireRequest.displayName = 'proto.tprmquestionnaire.SendQuestionnaireRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SendQuestionnaireResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SendQuestionnaireResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SendQuestionnaireResponse.displayName = 'proto.tprmquestionnaire.SendQuestionnaireResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.QuestionnaireRequestSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.QuestionnaireRequestSummary.displayName = 'proto.tprmquestionnaire.QuestionnaireRequestSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest.displayName = 'proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.displayName = 'proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ListReceivedQuestionnairesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.displayName = 'proto.tprmquestionnaire.ListReceivedQuestionnairesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ListReceivedQuestionnairesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.displayName = 'proto.tprmquestionnaire.ListReceivedQuestionnairesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.Comment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.Comment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.Comment.displayName = 'proto.tprmquestionnaire.Comment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.CreateCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.CreateCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.CreateCommentRequest.displayName = 'proto.tprmquestionnaire.CreateCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListCommentThreadRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.ListCommentThreadRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListCommentThreadRequest.displayName = 'proto.tprmquestionnaire.ListCommentThreadRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.ListCommentThreadResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.ListCommentThreadResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.ListCommentThreadResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.ListCommentThreadResponse.displayName = 'proto.tprmquestionnaire.ListCommentThreadResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.Empty.displayName = 'proto.tprmquestionnaire.Empty';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SupplementalInput.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SupplementalInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SupplementalInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SupplementalInput.toObject = function(includeInstance, msg) {
  var f, obj = {
    kind: jspb.Message.getFieldWithDefault(msg, 1, 0),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    required: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    isList: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SupplementalInput}
 */
proto.tprmquestionnaire.SupplementalInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SupplementalInput;
  return proto.tprmquestionnaire.SupplementalInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SupplementalInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SupplementalInput}
 */
proto.tprmquestionnaire.SupplementalInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.tprmquestionnaire.SupplementalInputKind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequired(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SupplementalInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SupplementalInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SupplementalInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SupplementalInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequired();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getIsList();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional SupplementalInputKind kind = 1;
 * @return {!proto.tprmquestionnaire.SupplementalInputKind}
 */
proto.tprmquestionnaire.SupplementalInput.prototype.getKind = function() {
  return /** @type {!proto.tprmquestionnaire.SupplementalInputKind} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.tprmquestionnaire.SupplementalInputKind} value
 * @return {!proto.tprmquestionnaire.SupplementalInput} returns this
 */
proto.tprmquestionnaire.SupplementalInput.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.tprmquestionnaire.SupplementalInput.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SupplementalInput} returns this
 */
proto.tprmquestionnaire.SupplementalInput.prototype.setLabel = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.SupplementalInput} returns this
 */
proto.tprmquestionnaire.SupplementalInput.prototype.clearLabel = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.SupplementalInput.prototype.hasLabel = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool required = 3;
 * @return {boolean}
 */
proto.tprmquestionnaire.SupplementalInput.prototype.getRequired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.SupplementalInput} returns this
 */
proto.tprmquestionnaire.SupplementalInput.prototype.setRequired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool is_list = 4;
 * @return {boolean}
 */
proto.tprmquestionnaire.SupplementalInput.prototype.getIsList = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.SupplementalInput} returns this
 */
proto.tprmquestionnaire.SupplementalInput.prototype.setIsList = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ConditionRule.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ConditionRule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ConditionRule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ConditionRule.toObject = function(includeInstance, msg) {
  var f, obj = {
    dependsOnCoordinate: jspb.Message.getFieldWithDefault(msg, 1, ""),
    matchValue: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.ConditionRule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ConditionRule;
  return proto.tprmquestionnaire.ConditionRule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ConditionRule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.ConditionRule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDependsOnCoordinate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatchValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ConditionRule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ConditionRule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ConditionRule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ConditionRule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDependsOnCoordinate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMatchValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string depends_on_coordinate = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ConditionRule.prototype.getDependsOnCoordinate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ConditionRule} returns this
 */
proto.tprmquestionnaire.ConditionRule.prototype.setDependsOnCoordinate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string match_value = 2;
 * @return {string}
 */
proto.tprmquestionnaire.ConditionRule.prototype.getMatchValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ConditionRule} returns this
 */
proto.tprmquestionnaire.ConditionRule.prototype.setMatchValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.FormOption.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.FormOption.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.FormOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.FormOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 3, 0),
    supplementalList: jspb.Message.toObjectList(msg.getSupplementalList(),
    proto.tprmquestionnaire.SupplementalInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.FormOption}
 */
proto.tprmquestionnaire.FormOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.FormOption;
  return proto.tprmquestionnaire.FormOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.FormOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.FormOption}
 */
proto.tprmquestionnaire.FormOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 4:
      var value = new proto.tprmquestionnaire.SupplementalInput;
      reader.readMessage(value,proto.tprmquestionnaire.SupplementalInput.deserializeBinaryFromReader);
      msg.addSupplemental(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.FormOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.FormOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.FormOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSupplementalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.tprmquestionnaire.SupplementalInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.FormOption.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormOption} returns this
 */
proto.tprmquestionnaire.FormOption.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.tprmquestionnaire.FormOption.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormOption} returns this
 */
proto.tprmquestionnaire.FormOption.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 display_order = 3;
 * @return {number}
 */
proto.tprmquestionnaire.FormOption.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.FormOption} returns this
 */
proto.tprmquestionnaire.FormOption.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated SupplementalInput supplemental = 4;
 * @return {!Array<!proto.tprmquestionnaire.SupplementalInput>}
 */
proto.tprmquestionnaire.FormOption.prototype.getSupplementalList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.SupplementalInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.SupplementalInput, 4));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.SupplementalInput>} value
 * @return {!proto.tprmquestionnaire.FormOption} returns this
*/
proto.tprmquestionnaire.FormOption.prototype.setSupplementalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.tprmquestionnaire.SupplementalInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.SupplementalInput}
 */
proto.tprmquestionnaire.FormOption.prototype.addSupplemental = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.tprmquestionnaire.SupplementalInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormOption} returns this
 */
proto.tprmquestionnaire.FormOption.prototype.clearSupplementalList = function() {
  return this.setSupplementalList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.FormQuestion.repeatedFields_ = [5,6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.FormQuestion.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.FormQuestion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.FormQuestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormQuestion.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    text: jspb.Message.getFieldWithDefault(msg, 2, ""),
    responseType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 4, 0),
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.tprmquestionnaire.FormOption.toObject, includeInstance),
    dependsOnList: jspb.Message.toObjectList(msg.getDependsOnList(),
    proto.tprmquestionnaire.ConditionRule.toObject, includeInstance),
    supplementalList: jspb.Message.toObjectList(msg.getSupplementalList(),
    proto.tprmquestionnaire.SupplementalInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.FormQuestion}
 */
proto.tprmquestionnaire.FormQuestion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.FormQuestion;
  return proto.tprmquestionnaire.FormQuestion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.FormQuestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.FormQuestion}
 */
proto.tprmquestionnaire.FormQuestion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 3:
      var value = /** @type {!proto.tprmquestionnaire.QuestionResponseType} */ (reader.readEnum());
      msg.setResponseType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 5:
      var value = new proto.tprmquestionnaire.FormOption;
      reader.readMessage(value,proto.tprmquestionnaire.FormOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    case 6:
      var value = new proto.tprmquestionnaire.ConditionRule;
      reader.readMessage(value,proto.tprmquestionnaire.ConditionRule.deserializeBinaryFromReader);
      msg.addDependsOn(value);
      break;
    case 7:
      var value = new proto.tprmquestionnaire.SupplementalInput;
      reader.readMessage(value,proto.tprmquestionnaire.SupplementalInput.deserializeBinaryFromReader);
      msg.addSupplemental(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.FormQuestion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.FormQuestion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.FormQuestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormQuestion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResponseType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.tprmquestionnaire.FormOption.serializeBinaryToWriter
    );
  }
  f = message.getDependsOnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.tprmquestionnaire.ConditionRule.serializeBinaryToWriter
    );
  }
  f = message.getSupplementalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.tprmquestionnaire.SupplementalInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.FormQuestion.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
 */
proto.tprmquestionnaire.FormQuestion.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.tprmquestionnaire.FormQuestion.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
 */
proto.tprmquestionnaire.FormQuestion.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional QuestionResponseType response_type = 3;
 * @return {!proto.tprmquestionnaire.QuestionResponseType}
 */
proto.tprmquestionnaire.FormQuestion.prototype.getResponseType = function() {
  return /** @type {!proto.tprmquestionnaire.QuestionResponseType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.tprmquestionnaire.QuestionResponseType} value
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
 */
proto.tprmquestionnaire.FormQuestion.prototype.setResponseType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int32 display_order = 4;
 * @return {number}
 */
proto.tprmquestionnaire.FormQuestion.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
 */
proto.tprmquestionnaire.FormQuestion.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated FormOption options = 5;
 * @return {!Array<!proto.tprmquestionnaire.FormOption>}
 */
proto.tprmquestionnaire.FormQuestion.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.FormOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.FormOption, 5));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.FormOption>} value
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
*/
proto.tprmquestionnaire.FormQuestion.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.tprmquestionnaire.FormOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.FormOption}
 */
proto.tprmquestionnaire.FormQuestion.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.tprmquestionnaire.FormOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
 */
proto.tprmquestionnaire.FormQuestion.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};


/**
 * repeated ConditionRule depends_on = 6;
 * @return {!Array<!proto.tprmquestionnaire.ConditionRule>}
 */
proto.tprmquestionnaire.FormQuestion.prototype.getDependsOnList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ConditionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ConditionRule, 6));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ConditionRule>} value
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
*/
proto.tprmquestionnaire.FormQuestion.prototype.setDependsOnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.tprmquestionnaire.ConditionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.FormQuestion.prototype.addDependsOn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.tprmquestionnaire.ConditionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
 */
proto.tprmquestionnaire.FormQuestion.prototype.clearDependsOnList = function() {
  return this.setDependsOnList([]);
};


/**
 * repeated SupplementalInput supplemental = 7;
 * @return {!Array<!proto.tprmquestionnaire.SupplementalInput>}
 */
proto.tprmquestionnaire.FormQuestion.prototype.getSupplementalList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.SupplementalInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.SupplementalInput, 7));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.SupplementalInput>} value
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
*/
proto.tprmquestionnaire.FormQuestion.prototype.setSupplementalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.tprmquestionnaire.SupplementalInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.SupplementalInput}
 */
proto.tprmquestionnaire.FormQuestion.prototype.addSupplemental = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.tprmquestionnaire.SupplementalInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormQuestion} returns this
 */
proto.tprmquestionnaire.FormQuestion.prototype.clearSupplementalList = function() {
  return this.setSupplementalList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.FormSection.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.FormSection.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.FormSection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.FormSection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormSection.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dependsOnList: jspb.Message.toObjectList(msg.getDependsOnList(),
    proto.tprmquestionnaire.ConditionRule.toObject, includeInstance),
    questionsList: jspb.Message.toObjectList(msg.getQuestionsList(),
    proto.tprmquestionnaire.FormQuestion.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.FormSection}
 */
proto.tprmquestionnaire.FormSection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.FormSection;
  return proto.tprmquestionnaire.FormSection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.FormSection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.FormSection}
 */
proto.tprmquestionnaire.FormSection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 4:
      var value = new proto.tprmquestionnaire.ConditionRule;
      reader.readMessage(value,proto.tprmquestionnaire.ConditionRule.deserializeBinaryFromReader);
      msg.addDependsOn(value);
      break;
    case 5:
      var value = new proto.tprmquestionnaire.FormQuestion;
      reader.readMessage(value,proto.tprmquestionnaire.FormQuestion.deserializeBinaryFromReader);
      msg.addQuestions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.FormSection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.FormSection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.FormSection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.FormSection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDependsOnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.tprmquestionnaire.ConditionRule.serializeBinaryToWriter
    );
  }
  f = message.getQuestionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.tprmquestionnaire.FormQuestion.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.FormSection.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormSection} returns this
 */
proto.tprmquestionnaire.FormSection.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tprmquestionnaire.FormSection.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.FormSection} returns this
 */
proto.tprmquestionnaire.FormSection.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 display_order = 3;
 * @return {number}
 */
proto.tprmquestionnaire.FormSection.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.FormSection} returns this
 */
proto.tprmquestionnaire.FormSection.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated ConditionRule depends_on = 4;
 * @return {!Array<!proto.tprmquestionnaire.ConditionRule>}
 */
proto.tprmquestionnaire.FormSection.prototype.getDependsOnList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ConditionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.ConditionRule, 4));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ConditionRule>} value
 * @return {!proto.tprmquestionnaire.FormSection} returns this
*/
proto.tprmquestionnaire.FormSection.prototype.setDependsOnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.tprmquestionnaire.ConditionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.FormSection.prototype.addDependsOn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.tprmquestionnaire.ConditionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormSection} returns this
 */
proto.tprmquestionnaire.FormSection.prototype.clearDependsOnList = function() {
  return this.setDependsOnList([]);
};


/**
 * repeated FormQuestion questions = 5;
 * @return {!Array<!proto.tprmquestionnaire.FormQuestion>}
 */
proto.tprmquestionnaire.FormSection.prototype.getQuestionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.FormQuestion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.FormQuestion, 5));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.FormQuestion>} value
 * @return {!proto.tprmquestionnaire.FormSection} returns this
*/
proto.tprmquestionnaire.FormSection.prototype.setQuestionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.tprmquestionnaire.FormQuestion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.FormQuestion}
 */
proto.tprmquestionnaire.FormSection.prototype.addQuestions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.tprmquestionnaire.FormQuestion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.FormSection} returns this
 */
proto.tprmquestionnaire.FormSection.prototype.clearQuestionsList = function() {
  return this.setQuestionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.QuestionnaireForm.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.QuestionnaireForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.QuestionnaireForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionnaireForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    version: jspb.Message.getFieldWithDefault(msg, 4, 0),
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.tprmquestionnaire.FormSection.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.QuestionnaireForm}
 */
proto.tprmquestionnaire.QuestionnaireForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.QuestionnaireForm;
  return proto.tprmquestionnaire.QuestionnaireForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.QuestionnaireForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.QuestionnaireForm}
 */
proto.tprmquestionnaire.QuestionnaireForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 5:
      var value = new proto.tprmquestionnaire.FormSection;
      reader.readMessage(value,proto.tprmquestionnaire.FormSection.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.QuestionnaireForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.QuestionnaireForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionnaireForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.tprmquestionnaire.FormSection.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireForm} returns this
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireForm} returns this
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireForm} returns this
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 version = 4;
 * @return {number}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.QuestionnaireForm} returns this
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated FormSection sections = 5;
 * @return {!Array<!proto.tprmquestionnaire.FormSection>}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.FormSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.FormSection, 5));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.FormSection>} value
 * @return {!proto.tprmquestionnaire.QuestionnaireForm} returns this
*/
proto.tprmquestionnaire.QuestionnaireForm.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.tprmquestionnaire.FormSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.FormSection}
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.tprmquestionnaire.FormSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.QuestionnaireForm} returns this
 */
proto.tprmquestionnaire.QuestionnaireForm.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.QuestionnaireTemplate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.QuestionnaireTemplate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionnaireTemplate.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.QuestionnaireTemplate;
  return proto.tprmquestionnaire.QuestionnaireTemplate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.QuestionnaireTemplate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.QuestionnaireTemplate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.QuestionnaireTemplate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionnaireTemplate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate} returns this
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string questionnaire_form_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate} returns this
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate} returns this
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate} returns this
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 updated_at = 5;
 * @return {number}
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate} returns this
 */
proto.tprmquestionnaire.QuestionnaireTemplate.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest;
  return proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    templatesList: jspb.Message.toObjectList(msg.getTemplatesList(),
    proto.tprmquestionnaire.QuestionnaireTemplate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse;
  return proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.QuestionnaireTemplate;
      reader.readMessage(value,proto.tprmquestionnaire.QuestionnaireTemplate.deserializeBinaryFromReader);
      msg.addTemplates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTemplatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.QuestionnaireTemplate.serializeBinaryToWriter
    );
  }
};


/**
 * repeated QuestionnaireTemplate templates = 1;
 * @return {!Array<!proto.tprmquestionnaire.QuestionnaireTemplate>}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.prototype.getTemplatesList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.QuestionnaireTemplate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.QuestionnaireTemplate, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.QuestionnaireTemplate>} value
 * @return {!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse} returns this
*/
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.prototype.setTemplatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.QuestionnaireTemplate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.QuestionnaireTemplate}
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.prototype.addTemplates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.QuestionnaireTemplate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse} returns this
 */
proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.prototype.clearTemplatesList = function() {
  return this.setTemplatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetQuestionnaireFormRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireFormRequest}
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetQuestionnaireFormRequest;
  return proto.tprmquestionnaire.GetQuestionnaireFormRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireFormRequest}
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetQuestionnaireFormRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_form_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireFormRequest.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ExportFormCsvRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ExportFormCsvRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ExportFormCsvRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ExportFormCsvRequest}
 */
proto.tprmquestionnaire.ExportFormCsvRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ExportFormCsvRequest;
  return proto.tprmquestionnaire.ExportFormCsvRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ExportFormCsvRequest}
 */
proto.tprmquestionnaire.ExportFormCsvRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ExportFormCsvRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ExportFormCsvRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ExportFormCsvRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_form_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ExportFormCsvRequest.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ExportFormCsvRequest} returns this
 */
proto.tprmquestionnaire.ExportFormCsvRequest.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ExportFormCsvResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ExportFormCsvResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ExportFormCsvResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ExportFormCsvResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    csv: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ExportFormCsvResponse}
 */
proto.tprmquestionnaire.ExportFormCsvResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ExportFormCsvResponse;
  return proto.tprmquestionnaire.ExportFormCsvResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ExportFormCsvResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ExportFormCsvResponse}
 */
proto.tprmquestionnaire.ExportFormCsvResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCsv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ExportFormCsvResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ExportFormCsvResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ExportFormCsvResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ExportFormCsvResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCsv();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string csv = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ExportFormCsvResponse.prototype.getCsv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ExportFormCsvResponse} returns this
 */
proto.tprmquestionnaire.ExportFormCsvResponse.prototype.setCsv = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ImportFormCsvRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ImportFormCsvRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ImportFormCsvRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ImportFormCsvRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    csv: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ImportFormCsvRequest}
 */
proto.tprmquestionnaire.ImportFormCsvRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ImportFormCsvRequest;
  return proto.tprmquestionnaire.ImportFormCsvRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ImportFormCsvRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ImportFormCsvRequest}
 */
proto.tprmquestionnaire.ImportFormCsvRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCsv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ImportFormCsvRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ImportFormCsvRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ImportFormCsvRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ImportFormCsvRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCsv();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ImportFormCsvRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ImportFormCsvRequest} returns this
 */
proto.tprmquestionnaire.ImportFormCsvRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string csv = 2;
 * @return {string}
 */
proto.tprmquestionnaire.ImportFormCsvRequest.prototype.getCsv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ImportFormCsvRequest} returns this
 */
proto.tprmquestionnaire.ImportFormCsvRequest.prototype.setCsv = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ImportFormCsvResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ImportFormCsvResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ImportFormCsvResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ImportFormCsvResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ImportFormCsvResponse}
 */
proto.tprmquestionnaire.ImportFormCsvResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ImportFormCsvResponse;
  return proto.tprmquestionnaire.ImportFormCsvResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ImportFormCsvResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ImportFormCsvResponse}
 */
proto.tprmquestionnaire.ImportFormCsvResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ImportFormCsvResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ImportFormCsvResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ImportFormCsvResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ImportFormCsvResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string questionnaire_form_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ImportFormCsvResponse.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ImportFormCsvResponse} returns this
 */
proto.tprmquestionnaire.ImportFormCsvResponse.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SendQuestionnaireRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SendQuestionnaireRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireTemplateId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    vendorId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    dueDate: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SendQuestionnaireRequest}
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SendQuestionnaireRequest;
  return proto.tprmquestionnaire.SendQuestionnaireRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SendQuestionnaireRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SendQuestionnaireRequest}
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireTemplateId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDueDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SendQuestionnaireRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SendQuestionnaireRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireTemplateId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVendorId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string questionnaire_template_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.prototype.getQuestionnaireTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SendQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.prototype.setQuestionnaireTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string vendor_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.prototype.getVendorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SendQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.prototype.setVendorId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SendQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SendQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 due_date = 5;
 * @return {number}
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.prototype.getDueDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.SendQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.prototype.setDueDate = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.SendQuestionnaireRequest} returns this
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.prototype.clearDueDate = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.SendQuestionnaireRequest.prototype.hasDueDate = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SendQuestionnaireResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SendQuestionnaireResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SendQuestionnaireResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SendQuestionnaireResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sourceQuestionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SendQuestionnaireResponse}
 */
proto.tprmquestionnaire.SendQuestionnaireResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SendQuestionnaireResponse;
  return proto.tprmquestionnaire.SendQuestionnaireResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SendQuestionnaireResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SendQuestionnaireResponse}
 */
proto.tprmquestionnaire.SendQuestionnaireResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceQuestionnaireRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SendQuestionnaireResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SendQuestionnaireResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SendQuestionnaireResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SendQuestionnaireResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSourceQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string source_questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.SendQuestionnaireResponse.prototype.getSourceQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SendQuestionnaireResponse} returns this
 */
proto.tprmquestionnaire.SendQuestionnaireResponse.prototype.setSourceQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.QuestionnaireRequestSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.QuestionnaireRequestSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    vendorId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    requestingOrgName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    dueDate: jspb.Message.getFieldWithDefault(msg, 6, 0),
    status: jspb.Message.getFieldWithDefault(msg, 7, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.QuestionnaireRequestSummary;
  return proto.tprmquestionnaire.QuestionnaireRequestSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.QuestionnaireRequestSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestingOrgName(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDueDate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.QuestionnaireRequestSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.QuestionnaireRequestSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVendorId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRequestingOrgName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string vendor_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getVendorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setVendorId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string requesting_org_name = 5;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getRequestingOrgName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setRequestingOrgName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 due_date = 6;
 * @return {number}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getDueDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setDueDate = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.clearDueDate = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.hasDueDate = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 created_at = 8;
 * @return {number}
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary} returns this
 */
proto.tprmquestionnaire.QuestionnaireRequestSummary.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    vendorId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest}
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest;
  return proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest}
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVendorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string vendor_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest.prototype.getVendorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest} returns this
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorRequest.prototype.setVendorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestsList: jspb.Message.toObjectList(msg.getRequestsList(),
    proto.tprmquestionnaire.QuestionnaireRequestSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse}
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse;
  return proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse}
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.QuestionnaireRequestSummary;
      reader.readMessage(value,proto.tprmquestionnaire.QuestionnaireRequestSummary.deserializeBinaryFromReader);
      msg.addRequests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.QuestionnaireRequestSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated QuestionnaireRequestSummary requests = 1;
 * @return {!Array<!proto.tprmquestionnaire.QuestionnaireRequestSummary>}
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.prototype.getRequestsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.QuestionnaireRequestSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.QuestionnaireRequestSummary, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.QuestionnaireRequestSummary>} value
 * @return {!proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse} returns this
*/
proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.prototype.setRequestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.QuestionnaireRequestSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary}
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.prototype.addRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.QuestionnaireRequestSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse} returns this
 */
proto.tprmquestionnaire.ListSentQuestionnairesForVendorResponse.prototype.clearRequestsList = function() {
  return this.setRequestsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListReceivedQuestionnairesRequest;
  return proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestsList: jspb.Message.toObjectList(msg.getRequestsList(),
    proto.tprmquestionnaire.QuestionnaireRequestSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListReceivedQuestionnairesResponse;
  return proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.QuestionnaireRequestSummary;
      reader.readMessage(value,proto.tprmquestionnaire.QuestionnaireRequestSummary.deserializeBinaryFromReader);
      msg.addRequests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.QuestionnaireRequestSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated QuestionnaireRequestSummary requests = 1;
 * @return {!Array<!proto.tprmquestionnaire.QuestionnaireRequestSummary>}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.prototype.getRequestsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.QuestionnaireRequestSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.QuestionnaireRequestSummary, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.QuestionnaireRequestSummary>} value
 * @return {!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse} returns this
*/
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.prototype.setRequestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.QuestionnaireRequestSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.QuestionnaireRequestSummary}
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.prototype.addRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.QuestionnaireRequestSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse} returns this
 */
proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.prototype.clearRequestsList = function() {
  return this.setRequestsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.Comment.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.Comment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.Comment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.Comment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sectionNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
    questionNumber: jspb.Message.getFieldWithDefault(msg, 4, 0),
    authorSide: jspb.Message.getFieldWithDefault(msg, 5, 0),
    authorDisplayName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    body: jspb.Message.getFieldWithDefault(msg, 7, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 8, 0),
    isDraft: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.Comment}
 */
proto.tprmquestionnaire.Comment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.Comment;
  return proto.tprmquestionnaire.Comment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.Comment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.Comment}
 */
proto.tprmquestionnaire.Comment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSectionNumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionNumber(value);
      break;
    case 5:
      var value = /** @type {!proto.tprmquestionnaire.QuestionnaireCommentAuthorSide} */ (reader.readEnum());
      msg.setAuthorSide(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorDisplayName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDraft(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.Comment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.Comment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.Comment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.Comment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getAuthorSide();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getAuthorDisplayName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getIsDraft();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.Comment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string questionnaire_request_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.Comment.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 section_number = 3;
 * @return {number}
 */
proto.tprmquestionnaire.Comment.prototype.getSectionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setSectionNumber = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.clearSectionNumber = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.Comment.prototype.hasSectionNumber = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 question_number = 4;
 * @return {number}
 */
proto.tprmquestionnaire.Comment.prototype.getQuestionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setQuestionNumber = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.clearQuestionNumber = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.Comment.prototype.hasQuestionNumber = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional QuestionnaireCommentAuthorSide author_side = 5;
 * @return {!proto.tprmquestionnaire.QuestionnaireCommentAuthorSide}
 */
proto.tprmquestionnaire.Comment.prototype.getAuthorSide = function() {
  return /** @type {!proto.tprmquestionnaire.QuestionnaireCommentAuthorSide} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.tprmquestionnaire.QuestionnaireCommentAuthorSide} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setAuthorSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string author_display_name = 6;
 * @return {string}
 */
proto.tprmquestionnaire.Comment.prototype.getAuthorDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setAuthorDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string body = 7;
 * @return {string}
 */
proto.tprmquestionnaire.Comment.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 created_at = 8;
 * @return {number}
 */
proto.tprmquestionnaire.Comment.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool is_draft = 9;
 * @return {boolean}
 */
proto.tprmquestionnaire.Comment.prototype.getIsDraft = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.Comment} returns this
 */
proto.tprmquestionnaire.Comment.prototype.setIsDraft = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.CreateCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.CreateCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.CreateCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sectionNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    questionNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
    body: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.CreateCommentRequest}
 */
proto.tprmquestionnaire.CreateCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.CreateCommentRequest;
  return proto.tprmquestionnaire.CreateCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.CreateCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.CreateCommentRequest}
 */
proto.tprmquestionnaire.CreateCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSectionNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.CreateCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.CreateCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.CreateCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 section_number = 2;
 * @return {number}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.getSectionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.CreateCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.setSectionNumber = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.CreateCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.clearSectionNumber = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.hasSectionNumber = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 question_number = 3;
 * @return {number}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.getQuestionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.CreateCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.setQuestionNumber = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.CreateCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.clearQuestionNumber = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.hasQuestionNumber = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string body = 4;
 * @return {string}
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateCommentRequest} returns this
 */
proto.tprmquestionnaire.CreateCommentRequest.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListCommentThreadRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListCommentThreadRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sectionNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    questionNumber: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListCommentThreadRequest}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListCommentThreadRequest;
  return proto.tprmquestionnaire.ListCommentThreadRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListCommentThreadRequest}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSectionNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListCommentThreadRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListCommentThreadRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string questionnaire_request_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.ListCommentThreadRequest} returns this
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 section_number = 2;
 * @return {number}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.getSectionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ListCommentThreadRequest} returns this
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.setSectionNumber = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.ListCommentThreadRequest} returns this
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.clearSectionNumber = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.hasSectionNumber = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 question_number = 3;
 * @return {number}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.getQuestionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.ListCommentThreadRequest} returns this
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.setQuestionNumber = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.ListCommentThreadRequest} returns this
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.clearQuestionNumber = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.ListCommentThreadRequest.prototype.hasQuestionNumber = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.ListCommentThreadResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.ListCommentThreadResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.ListCommentThreadResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.ListCommentThreadResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListCommentThreadResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    commentsList: jspb.Message.toObjectList(msg.getCommentsList(),
    proto.tprmquestionnaire.Comment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.ListCommentThreadResponse}
 */
proto.tprmquestionnaire.ListCommentThreadResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.ListCommentThreadResponse;
  return proto.tprmquestionnaire.ListCommentThreadResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.ListCommentThreadResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.ListCommentThreadResponse}
 */
proto.tprmquestionnaire.ListCommentThreadResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.Comment;
      reader.readMessage(value,proto.tprmquestionnaire.Comment.deserializeBinaryFromReader);
      msg.addComments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.ListCommentThreadResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.ListCommentThreadResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.ListCommentThreadResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.ListCommentThreadResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.Comment.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Comment comments = 1;
 * @return {!Array<!proto.tprmquestionnaire.Comment>}
 */
proto.tprmquestionnaire.ListCommentThreadResponse.prototype.getCommentsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.Comment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.Comment, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.Comment>} value
 * @return {!proto.tprmquestionnaire.ListCommentThreadResponse} returns this
*/
proto.tprmquestionnaire.ListCommentThreadResponse.prototype.setCommentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.Comment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.Comment}
 */
proto.tprmquestionnaire.ListCommentThreadResponse.prototype.addComments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.Comment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.ListCommentThreadResponse} returns this
 */
proto.tprmquestionnaire.ListCommentThreadResponse.prototype.clearCommentsList = function() {
  return this.setCommentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.Empty}
 */
proto.tprmquestionnaire.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.Empty;
  return proto.tprmquestionnaire.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.Empty}
 */
proto.tprmquestionnaire.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.tprmquestionnaire.QuestionResponseType = {
  FREE_TEXT: 0,
  SINGLE_SELECT: 1,
  MULTI_SELECT: 2,
  FILE_UPLOAD: 3
};

/**
 * @enum {number}
 */
proto.tprmquestionnaire.SupplementalInputKind = {
  SUPPLEMENTAL_UNSPECIFIED: 0,
  TEXT_INFO: 1,
  ATTACHMENT: 2
};

/**
 * @enum {number}
 */
proto.tprmquestionnaire.QuestionnaireCommentAuthorSide = {
  AUTHOR_SIDE_UNSPECIFIED: 0,
  CUSTOMER: 1,
  VENDOR: 2
};

goog.object.extend(exports, proto.tprmquestionnaire);
